/**
 * 구간 반복 중앙 텍스트
 */
import { SbsPlayerGlobal } from '../../../../common';
import SbsPlayerLogger from '../../../../utils/logger';

customElements.define(
  'sbs-player-center-repeat-text',
  class extends HTMLElement {
    constructor() {
      super();
      this.startTime = 0;
      this.endTime = 0;
      this.startText = '00:00';
      this.endText = '00:00';
      this.visible = false;
      this.hideTimeout = null;
    }

    static get observedAttributes() {
      return ['text'];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
        if (name === 'text' && oldValue !== newValue) {
          this.text = newValue;
        }
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
        this.setupEventListeners();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    setupEventListeners() {
      // repeat-section에서 전송하는 구간 변경 이벤트 리스너
      SbsPlayerGlobal.events.addEventListener(
        'repeat-section-changed',
        (data) => {
          this.startTime = data.startTime;
          this.endTime = data.endTime;
          this.startText = data.startText;
          this.endText = data.endText;
          this.updateDisplay();
        }
      );

      // repeat mode 상태 변경 리스너
      SbsPlayerGlobal.events.addEventListener(
        'repeat-mode-changed',
        (enabled) => {
          this.visible = enabled;
          this.updateDisplay();
        }
      );
    }

    updateDisplay() {
      if (this.visible) {
        this.style.display = 'block';
        const textElement = this.querySelector('.playerRepeat-text');
        if (textElement) {
          const oldContent = textElement.textContent;
          const newContent = `${this.startText}~${this.endText}`;
          
          if (oldContent !== newContent) {
            textElement.textContent = newContent;
            this.showTemporarily();
          }
        }
      } else {
        this.style.display = 'none';
      }
    }

    render() {
      try {
        this.innerHTML = `<div class="playerRepeat-text hide">00:00~00:00</div>`;
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    showTemporarily() {
      try {
        const textElement = this.querySelector('.playerRepeat-text');
        if (textElement) {
          if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
          }
          
          textElement.classList.remove('hide');
          
          this.hideTimeout = setTimeout(() => {
            textElement.classList.add('hide');
            this.hideTimeout = null;
          }, 3000);
        }
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
      } catch (error) {
        console.log(error);
      }
    }
  }
);
